import { render, staticRenderFns } from "./noorplay_Footer.vue?vue&type=template&id=3c1ac532&scoped=true&"
import script from "./noorplay_Footer.vue?vue&type=script&lang=js&"
export * from "./noorplay_Footer.vue?vue&type=script&lang=js&"
import style0 from "./noorplay_Footer.vue?vue&type=style&index=0&id=3c1ac532&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1ac532",
  null
  
)

export default component.exports